import SearchBar from './SearchBar';
import ImageBox from './ImageBox';
import styles from '../Styles/Main.css';
import React, { useState } from "react";

const App = () => {

	const[imgTerm, setImgTerm] = useState('');


	return(
		<div className = "container">
			<SearchBar imgTerm={imgTerm} setImgTerm={setImgTerm}/>
			<ImageBox 
				imgTerm={imgTerm} setImgTerm={setImgTerm} 
			/>
		</div>
		);
};

export default App;